import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";

import DatePicker from "react-datepicker";


interface DatePickerExProps {
  onDateChanged: (date: Date | null) => void;
  selectedDate: Date | null;
  isDisabled: boolean;
}

const DatePickerEx = ({ selectedDate, onDateChanged, isDisabled }: DatePickerExProps) => {
  return (
    <DatePicker
      selected={selectedDate}
      onChange={onDateChanged}
      readOnly={isDisabled}
      isClearable={!isDisabled}
      // locale={"th"}
      dateFormat={"dd/MM/yyyy"} className="form-control p-1" portalId="root-portal"
    ></DatePicker>

  )
}

export default DatePickerEx

